import { gql } from "@apollo/client";

export const getLanguages = gql`
    query getLanguages {
        language {
            language_id
            name
            code
        }
    }
`;

export const getDefaulFailureTypeTranslations = gql`
    query getDefaulFailureTypeTranslations {
        default_failure_type_translations {
            default_failure_type_translation_id
            failure_type_id
            language {
                language_id
                code
            }
            translated_name
        }
    }
`;

export const getDefaultFailureCodeTranslations = gql`
    query getDefaulFailureCodeTranslations {
        default_failure_code_translations {
            default_failure_code_translation_id
            failure_code_id
            language {
                language_id
                code
            }
            translated_name
        }
    }
`;
